<div>

    <div (click)="onNavigateTo()"
         class="d-flex ion-align-items-center ion-justify-content-between ion-activatable ripple-parent rounded-rectangle">
        <ion-ripple-effect></ion-ripple-effect>

        <div class="w-100 d-flex ion-justify-content-between ion-align-items-center">
            <div class="d-flex ion-align-items-center">

                <div>
                    <ng-content select="[leftTitle]"></ng-content>
                </div>

                <div>
                    <div class="ts-h5-sans">{{ title }}</div>
                    <div class="ts-caption pt-xs">{{ subTitle }}</div>
                </div>

            </div>

            <div *ngIf="navigateTo">
                <span class="material-symbols-outlined text-font-dark">chevron_right</span>
            </div>
        </div>

    </div>

    <div class="mt-sm pb-sm" #contentBoxRef>
        <ng-content select="[content]"></ng-content>
    </div>
</div>
